import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-fill_email_address_on_pre_sign_up_form-click';

/**
 * Track user fill email address on pre sign up form
 */
export function trackSignupFillEmailAddressOnPreSignUpFormClick(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'email-address-pre-sign-up-form',
    googleTagManagerEvent: 'email-address-pre-sign-up-form',
    pixelCustomDataParams,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
